import {
  MutationHookOptions,
  QueryHookOptions,
  useMutation,
  useLazyQuery
} from '@apollo/client';
import {
  SEND_MESSAGE,
  SEND_MESSAGE_BOOLEAN_QUERY
} from './graphql/chat/mutation';
import {
  GET_CONVERSATION_ID,
  GET_BOOLEAN_QUERY_CONVERSATION_ID
} from './graphql/chat/query';

export interface GetConversationIdResponse {
  chat_getConversationId: {
    conversationId: string;
  };
}

export interface GetBooleanConversationIdResponse {
  chat_getBooleanConversationId: {
    conversationId: string;
  };
}

export interface SendMessageParams {
  conversationId: string;
  content: string;
  projectId: string;
}

export interface BooleanConversation {
  id: string;
  question: string;
  response: string;
  include?: string[][];
  exclude?: string[];
  createdAt: string;
}

export interface SendMessageBooleanResponse {
  chat_chatPostBoolean: BooleanConversation;
}

export interface Conversation {
  id: string;
  answer: string;
  question: string;
  createdAt: string;
}

export interface SendMessageResponse {
  chat_chatPost: Conversation;
}

const useChat = () => {
  const useGetConversationId = (
    option?: QueryHookOptions<GetConversationIdResponse>
  ) => {
    return useLazyQuery<GetConversationIdResponse>(GET_CONVERSATION_ID, {
      ...option
    });
  };

  const useGetBooleanConversationId = (
    option?: QueryHookOptions<GetBooleanConversationIdResponse>
  ) => {
    return useLazyQuery<GetBooleanConversationIdResponse>(
      GET_BOOLEAN_QUERY_CONVERSATION_ID,
      {
        ...option
      }
    );
  };

  const useSendMessage = (
    options?: MutationHookOptions<SendMessageResponse, SendMessageParams>
  ) => {
    return useMutation<SendMessageResponse, SendMessageParams>(
      SEND_MESSAGE,
      options ?? {}
    );
  };

  const useSendBooleanMessage = (
    options?: MutationHookOptions<SendMessageBooleanResponse, SendMessageParams>
  ) => {
    return useMutation<SendMessageBooleanResponse, SendMessageParams>(
      SEND_MESSAGE_BOOLEAN_QUERY,
      options ?? {}
    );
  };

  return {
    useGetConversationId,
    useSendMessage,
    useSendBooleanMessage,
    useGetBooleanConversationId
  };
};

export default useChat;
